import styled from 'styled-components';

export const CanvaFiltersSection = styled.div`
  display: inline-block;
  width: 100%;
  text-align: left;
`;

export const CanvaColorsSubtitle = styled.div`
    display: flex;
    justify-content: begin;
    margin-bottom: 5px;
`;

export const CanvaColorsSection = styled.div`
    width: 100%;
    display: flex;  
    flex-direction: ${({ isColor }) => isColor ? 'row' : 'column'};
    align-items: flex-start;
    margin-bottom: 10px;
    font-size: 16px;
    overflow-x: auto;
`;

export const CanvaColorsContainer = styled.div`
    display: flex;
    padding: 0 20px 20px 0;
`;

export const CanvaEditorButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 15px 0px 15px 0px;
    flex-wrap: wrap;
    width: 100%;
`;
